import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface FormPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const FormPopup: React.FC<FormPopupProps> = ({ isOpen, onClose }) => {
  // Track iframe load to enable smooth fade-in and avoid flashing
  const [iframeLoaded, setIframeLoaded] = useState(false);

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />
          
          {/* Popup Container */}
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
          >
            <div className="relative w-full max-w-lg max-h-[90vh] bg-primary rounded-2xl shadow-2xl overflow-hidden">
              {/* Close Button */}
              <button
                onClick={onClose}
                className="absolute top-4 right-4 z-10 w-8 h-8 bg-black/20 hover:bg-black/40 rounded-full flex items-center justify-center transition-colors duration-200 group"
                aria-label="Close form"
              >
                <svg className="w-4 h-4 text-white group-hover:text-highlight" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              
              {/* Header */}
              <div className="p-6 pb-4 border-b border-secondary/20">
                <h3 className="text-2xl font-light text-gradient mb-2">Request Custom Quote</h3>
                <p className="text-secondary/80 text-sm">Get personalized recommendations for your luxury AV experience</p>
              </div>
              
              {/* Form Container */}
              <div className="relative">
                <iframe
                  src="https://api.leadconnectorhq.com/widget/form/agfreWNoXzwzmApfwMVP"
                  style={{ width: "100%", height: "570px", border: "none", borderRadius: "25px" }}
                  id="inline-agfreWNoXzwzmApfwMVP"
                  data-layout="{'id':'INLINE'}"
                  data-trigger-type="alwaysShow"
                  data-trigger-value=""
                  data-activation-type="alwaysActivated"
                  data-activation-value=""
                  data-deactivation-type="neverDeactivate"
                  data-deactivation-value=""
                  data-form-name="Custom Quote Form - Parallax"
                  data-height="570"
                  data-layout-iframe-id="inline-agfreWNoXzwzmApfwMVP"
                  data-form-id="agfreWNoXzwzmApfwMVP"
                  title="Custom Quote Form - Parallax"
                  loading="lazy"
                  onLoad={() => setIframeLoaded(true)}
                  className={`transition-opacity duration-300 ${iframeLoaded ? 'opacity-100' : 'opacity-0'}`}
                />
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default FormPopup; 
